var impressum = "版權聲明";
var privacy = "隱私權與法律";
var recallInfo = "召回資訊";
var signOut = "登出";
var zh_tw = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { zh_tw as default, impressum, privacy, recallInfo, signOut };
